import { EmbeddedVideo } from "./EmbeddedVideo";

export const VideoContainer = () => {
  return (
    <div class="flex md:flex-row flex-col justify-center items-center">
      <EmbeddedVideo
        title={"Riddle me this..."}
        link={
          "https://www.youtube.com/embed/Gmmd_-tKovY?si=fENEwtgTGRl9mhKx&feature=shared&loop=1&rel=0&showinfo=0&color=white&iv_load_policy=3&mute=1"
        }
      />
      <EmbeddedVideo
        title={"Wasatch $110K Tour"}
        link={
          "https://www.youtube.com/embed/ZkteY3iNy1Y?si=ur8ypnP2bFzPL8uj&feature=shared&loop=1&rel=0&showinfo=0&color=white&iv_load_policy=3&mute=1"
        }
      />
    </div>
  );
};
